(() => {
  if (window.cartGoalsListenerAdded) return;
  window.cartGoalsListenerAdded = true;

  // Verzendgrenzen in centen, op basis van het gekozen Shopify-land.
  const shippingThresholds = { NL: 4500, BE: 6500, DE: 10000 };
  const country = document.querySelector('[data-cart-goals]')?.dataset.country;
  const shippingThreshold = shippingThresholds[country] || null;
  const shippingReached = (total) => shippingThreshold !== null && total >= shippingThreshold;
  const milestones = new Map();
  const addReward = (amount, preview, emphasis) => {
    const rewards = milestones.get(amount) || [];
    rewards.push({ preview, emphasis });
    milestones.set(amount, rewards);
  };

  addReward(3000, 'bestellen', 'bestellen');
  if (shippingThreshold !== null) addReward(shippingThreshold, 'gratis verzending', 'gratis verzending');
  addReward(4500, 'één gratis cadeau', 'één gratis cadeau');
  addReward(7500, 'meer cadeaukeuze', 'meer cadeaukeuze');
  [10000, 15000, 20000].forEach((amount) => addReward(amount, 'nog meer cadeaukeuze', 'meer cadeaukeuze'));
  addReward(25000, 'ruimste cadeaukeuze', 'de ruimste cadeaukeuze');

  const goals = [...milestones.entries()].sort(([a], [b]) => a - b).map(([amount, rewards]) => {
    const thresholdLabel = `€${amount / 100}`;
    const preview = rewards.map((reward) => reward.preview).join(' + ');
    const emphasis = rewards.map((reward) => reward.emphasis).join(' en ');
    return {
      amount,
      preview: `${preview} vanaf ${thresholdLabel}`,
      emphasis,
      message: (left, total) => {
        if (amount === 3000) return `Nog ${left} om te kunnen bestellen vanaf ${thresholdLabel}.`;
        const prefix = shippingReached(total) ? 'Gratis verzending ✓ ' : '';
        return `${prefix}Nog ${left} voor ${emphasis} vanaf ${thresholdLabel}.`;
      }
    };
  });

  const animationTimers = new WeakMap();
  let lastState = null;

  const formatMoney = (cents, currency = 'EUR') => new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency
  }).format(cents / 100).replace(/\s/g, '');

  const addUpcomingItem = (container, value, separator) => {
    if (separator) {
      const separatorElement = document.createElement('span');
      separatorElement.className = 'cart-goals__separator';
      separatorElement.textContent = '·';
      container.appendChild(separatorElement);
    }
    const item = document.createElement('strong');
    item.textContent = value;
    container.appendChild(item);
  };

  const appendTextWithAmount = (fragment, value, amount) => {
    const parts = value.split(amount);
    fragment.appendChild(document.createTextNode(parts[0]));
    if (parts.length > 1) {
      const amountElement = document.createElement('strong');
      amountElement.className = 'cart-goals__amount';
      amountElement.textContent = amount;
      fragment.appendChild(amountElement);
      fragment.appendChild(document.createTextNode(parts.slice(1).join(amount)));
    }
  };

  const setGoalMessage = (element, value, amount, emphasis) => {
    const emphasisIndex = value.indexOf(emphasis);
    if (emphasisIndex === -1) {
      element.textContent = value;
      return;
    }

    const fragment = document.createDocumentFragment();
    appendTextWithAmount(fragment, value.slice(0, emphasisIndex), amount);
    const emphasisElement = document.createElement('strong');
    emphasisElement.className = 'cart-goals__reward';
    emphasisElement.textContent = emphasis;
    fragment.appendChild(emphasisElement);
    appendTextWithAmount(fragment, value.slice(emphasisIndex + emphasis.length), amount);
    element.replaceChildren(fragment);
  };

  const getGoalState = (total) => {
    const foundIndex = goals.findIndex((goal) => total < goal.amount);
    const complete = foundIndex === -1;
    const index = complete ? goals.length : foundIndex;
    const goal = complete ? goals[goals.length - 1] : goals[index];
    const previousAmount = complete
      ? goals[goals.length - 2].amount
      : index > 0 ? goals[index - 1].amount : 0;
    const progress = complete
      ? 100
      : Math.max(0, Math.min(100, ((total - previousAmount) / (goal.amount - previousAmount)) * 100));
    return { index, complete, goal, previousAmount, progress };
  };

  const setFillInstantly = (fill, progress) => {
    fill.style.transition = 'none';
    fill.style.width = `${progress}%`;
    void fill.offsetWidth;
    fill.style.transition = '';
  };

  const updateFill = (fill, state, previousState) => {
    const existingTimer = animationTimers.get(fill);
    if (existingTimer) window.clearTimeout(existingTimer);

    const initialized = fill.dataset.cartGoalsInitialized === 'true';
    if (!initialized) {
      setFillInstantly(fill, previousState ? previousState.progress : state.progress);
      fill.dataset.cartGoalsInitialized = 'true';
    }

    if (!previousState || previousState.index === state.index) {
      window.requestAnimationFrame(() => {
        fill.style.width = `${state.progress}%`;
      });
      return;
    }

    const movingForward = state.index > previousState.index;
    fill.style.width = movingForward ? '100%' : '0%';
    if (state.complete) return;

    const timer = window.setTimeout(() => {
      setFillInstantly(fill, movingForward ? 0 : 100);
      window.requestAnimationFrame(() => {
        fill.style.width = `${state.progress}%`;
      });
    }, 520);
    animationTimers.set(fill, timer);
  };

  const updateGoal = (element, total, currency, previousState = lastState) => {
    const state = getGoalState(total);
    const message = element.querySelector('[data-cart-goals-message]');
    const fill = element.querySelector('[data-cart-goals-fill]');
    const progress = element.querySelector('[data-cart-goals-progress]');
    const startLabel = element.querySelector('[data-cart-goals-start]');
    const targetLabel = element.querySelector('[data-cart-goals-target]');
    const upcoming = element.querySelector('[data-cart-goals-upcoming]');
    if (!message || !fill || !progress || !startLabel || !targetLabel || !upcoming) return;

    element.hidden = false;
    element.dataset.cartTotal = String(total);
    updateFill(fill, state, previousState);

    progress.setAttribute('aria-valuemin', String(state.previousAmount));
    progress.setAttribute('aria-valuemax', String(state.goal.amount));
    progress.setAttribute('aria-valuenow', String(Math.max(state.previousAmount, Math.min(state.goal.amount, total))));
    startLabel.textContent = state.previousAmount === 0 ? '€0' : `Vanaf ${formatMoney(state.previousAmount, currency)}`;
    targetLabel.textContent = state.complete
      ? `${formatMoney(state.goal.amount, currency)} bereikt`
      : state.index === 0
        ? `Bestellen vanaf ${formatMoney(state.goal.amount, currency)}`
        : state.goal.preview.charAt(0).toUpperCase() + state.goal.preview.slice(1);

    if (state.complete) {
      element.classList.add('cart-goals--complete');
      message.textContent = `${shippingReached(total) ? 'Gratis verzending ✓ ' : ''}Kies één gratis cadeau uit het volledige aanbod.`;
      progress.setAttribute('aria-valuetext', 'Alle winkelwagendoelen behaald');
      upcoming.hidden = true;
      return;
    }

    element.classList.remove('cart-goals--complete');
    const amountLeft = state.goal.amount - total;
    const formattedAmountLeft = formatMoney(amountLeft, currency);
    setGoalMessage(message, state.goal.message(formattedAmountLeft, total), formattedAmountLeft, state.goal.emphasis);
    progress.setAttribute('aria-valuetext', `${formattedAmountLeft} tot het volgende doel`);

    upcoming.replaceChildren();
    const laterGoals = goals.slice(state.index + 1);
    const visibleGoals = laterGoals.slice(0, 2);
    if (visibleGoals.length === 0) {
      upcoming.hidden = true;
      return;
    }

    const prefix = document.createElement('span');
    prefix.textContent = 'Volgende doelen: ';
    upcoming.appendChild(prefix);
    visibleGoals.forEach((laterGoal, index) => addUpcomingItem(upcoming, laterGoal.preview, index > 0));
    const remainingCount = laterGoals.length - visibleGoals.length;
    if (remainingCount > 0) {
      addUpcomingItem(upcoming, `+${remainingCount} ander${remainingCount === 1 ? ' doel' : 'e doelen'}`, true);
    }
    upcoming.hidden = false;
  };

  const updateAll = (cart) => {
    if (!cart) return;
    const total = Number(cart.total_price);
    if (!Number.isFinite(total)) return;
    const previousState = lastState;
    document.querySelectorAll('[data-cart-goals]').forEach((element) => {
      updateGoal(element, total, cart.currency || 'EUR', previousState);
    });
    lastState = getGoalState(total);
  };

  const updateFromMarkup = (root = document) => {
    const elements = root.matches?.('[data-cart-goals]')
      ? [root]
      : root.querySelectorAll?.('[data-cart-goals]') || [];
    let latestTotal = null;
    elements.forEach((element) => {
      const total = Number(element.dataset.cartTotal);
      if (Number.isFinite(total)) {
        updateGoal(element, total, element.dataset.currency || 'EUR', lastState);
        latestTotal = total;
      }
    });
    if (latestTotal !== null) lastState = getGoalState(latestTotal);
  };

  let fetchTimer;
  const refreshFromCart = (delay = 0) => {
    window.clearTimeout(fetchTimer);
    fetchTimer = window.setTimeout(async () => {
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
        if (!response.ok) return;
        updateAll(await response.json());
      } catch (error) {
        console.warn('Winkelwagendoelen konden niet worden bijgewerkt:', error);
      }
    }, delay);
  };

  updateFromMarkup();
  refreshFromCart();
  document.addEventListener('cart:updated', (event) => {
    if (event.detail?.cart && Number.isFinite(Number(event.detail.cart.total_price))) {
      updateAll(event.detail.cart);
    } else {
      refreshFromCart();
    }
  });
  document.addEventListener('cart:refresh', () => refreshFromCart(500));
  document.addEventListener('welcome-discount:activated', () => refreshFromCart(500));
  document.addEventListener('welcome-discount:deactivated', () => refreshFromCart(500));
  document.addEventListener('shopify:section:load', (event) => {
    updateFromMarkup(event.target);
    refreshFromCart();
  });

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) updateFromMarkup(node);
      });
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
